module.exports = __webpack_public_path__ + "static/media/cookLogo.c8dd5629.png";